import { useEffect, type ReactNode } from "react";
import { useThemeStore, type AppTheme } from "@/lib/theme/themeStore";

export interface ThemeProviderProps {
  children: ReactNode;
}

const themeClasses: Record<AppTheme, string> = {
  "light-flat": "theme-light-flat",
  dark: "theme-dark dark",
  "gradient-light": "theme-gradient-light",
};

export const ThemeProvider = ({ children }: ThemeProviderProps): JSX.Element => {
  const theme = useThemeStore((state) => state.theme);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("theme-light-flat", "theme-dark", "theme-gradient-light", "dark");
    root.classList.add(...themeClasses[theme].split(" "));
    root.dataset.theme = theme;
  }, [theme]);

  return <>{children}</>;
};
